export const paymentSettings = {
    "yearly_payment_settings_title": "Tarifas mensuales {{year}}",
    "maxNumberOfInstallments": "Cantidad máxima de cuotas",
    "oneTimeTitle": "Pago único: {{nameOfPayment}}",
    "monthlyYear": "Pagos mensuales {{year}}",
    "oneTime": "Nuevo pago único",
    "uploadExplain": "Descarga la plantilla de Excel. Después de ingresar los detalles, se puede cargar el archivo.",
    "downloadFile": "Descargar",
    "uploadFile": "Subir",
    "freezeOneTime": "Bloquear",
    "unfreezeOneTime": "Desbloquear",
    "addNew": "Añadir nuevo pago",
    "installments": "Cantidad de cuotas",
    "note": "Añadir nota",
    "createPayment": "Crear pago",
    "oneTimeSuccess": "¡Se creó con éxito! Cantidad de pagos: {{payments}}",
    "oneTimeError": "Ocurrió un error al crear un nuevo pago",
    "dragOrClickToUpload": "Arrastra el archivo PDF aquí o haz clic para abrir el cuadro de diálogo",
    "recordOffline": "Registrar el pago sin conexión para el edificio",
    "amountHeader": "Monto",
    "method": "Método de pago",
    "totalPayments": "{{num}} pagos del total de {{amount}} ILS para el apartamento {{apartmentNum}}",
    "dismiss": "Desestimar",
    "notifications": {
        "uploadFailure": "No se puede cargar el PDF",
        "approveSuccess": "¡Se aprobaron los pagos!"
    },
    "paidMonths": "Lista de pagos reales",
    "openedMonths": "Lista de pagos abiertos",
    "overpay": "No hay pagos abiertos para este apartamento o pagaste de más. Verifica la tabla con pagos abiertos",
    "noOpenedMonths": "No hay pagos abiertos relevantes para este apartamento",
    "paymentState": "Estado de pago",
    "active": "Activo",
    "inactive": "Detenido",
    "noAmountToUpdate": "No hay una cantidad definida para actualizar",
    "updatedMonthlySuccessfully": "Los pagos se han actualizado correctamente",
    "uploadedMonthlySuccessfully": "Los pagos se han actualizado con éxito por los años {{year}} y más allá",
    "uploadedOneTimeSuccessfully": "Pago único {{name}} añadido con éxito",
    "uploadedMonthlyNoUpdatedRows": "Los pagos del archivo seleccionado no se han actualizado",
    "uploadedMonthlyError": "Error al cargar el archivo de datos. Por favor envíe el archivo a -",
    "uploadHere": "Arrastra el archivo para subir los detalles",
    "name": "Introduzca su nombre",
    "amount": "Introduzca la cantidad",
    "month": "Mes",
    "year": "Año",
    "letsStartSettingsPayments": "Empecemos a configurar los pagos",
    "fillDetailsToCollectPrize": "Complete los detalles para cobrar el premio",
    "monthSelectionInfoPopUpText": "Hola <tenantName>,<br>Al pulsar un mes se deseleccionará y se cancelará el importe para su pago.<br><pay> <heartImg> - el pago en bllink no alcanza ningún límite de crédito.",
    "monthSelectionInfoPopUpText_pay": "Pagar",
    "dontShowThisMessageAgain": "No volver a mostrar este mensaje",
    "updateMonthlyRates": "Actualizar tarifas mensuales",
    "fixedAmount": "Cantidad fija",
    "variableAmount": "Importe variable",
    "updateFixedAmount": "Actualizar tarifas mensuales fijas para todos los departamentos. Puede actualizar la cantidad o actualizar una adición a una cantidad existente en un rango de fechas seleccionado",
    "amountUpdate": "Importe a actualizar",
    "addToExistingRate": "Añadir el importe a la tarifa existente",
    "startingFrom": "Empezando desde",
    "upTo": "Hasta",
    "update": "Actualizar",
    "updateFlexibleAmount": "Actualizar tarifas mensuales variables para todos los departamentos. Puede actualizar la cantidad o actualizar una adición a una cantidad existente en un rango de fechas seleccionado",
    "excelUpdate": "Actualizar desde Excel",
    "manualUpdate": "Actualización manual",
    "dragAndDrop": "Arrastrar y soltar archivo desde el banco",
    "exampleExcel": "Excel por ejemplo",
    "provideDate": "Proporcione un rango de fechas"
};
